import React from 'react';
import {
  Card,
  CardTitle,
  Button,
  CardBody,
  Typography,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { PAYMENTS_PATH } from '../../constants/links';

export const EmptyCard = () => {
  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }} data-component="PaymentMethodCardEmptyCard">
      <CardTitle
        header={(
          <Typography height="tight" variant="h3" weight="bold">
            Cards & Accounts
          </Typography>
        )}
      />
      <CardBody className="sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full">
        <Typography>
          Add credit cards, gift cards, PayPal and other payment methods to see all your online and
          in-store purchases.
        </Typography>
      </CardBody>
      <CardActions>
        <Button fullWidth variant="secondary" href={PAYMENTS_PATH}>
          Set Default Card
        </Button>
      </CardActions>
    </Card>
  );
};

EmptyCard.displayName = 'EmptyCard';